import portsApi from '@/framework/ports/portsApi';

const VisibilityChange = {
  onVisibilityChange: (
    callback: (visibilityState: 'hidden' | 'visible') => void
  ) => portsApi.on('VisibilityChange.onVisibilityChange', callback),
};

export default VisibilityChange;
